/* eslint-disable max-len */
enum LenderName {
    ROADRUNNER_FINANCIAL = 'Roadrunner Financial',
}

export default LenderName
